import React from "react";
// import Modal from '../Modal'
// import LoaderButton from "../LoaderButton";
import { translate } from "../utils/useful";
// import FormViewer from "../FormViewer";
// import SwitchInput from "../inputs/SwitchInput";
// import TopicView from "../views/messenger/sideBar/TopicView";
// import StagesManager from "../StagesManager";
// import Dropzone from 'react-dropzone'
import CustomDropZone from "../components/CustomDropZone";
import HttpServices from "../utils/Http.services";
import { nanoid } from "nanoid";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import { read, utils } from "xlsx";
import LoaderButton from "../components/LoaderButton";


class ImportModalFirst extends React.Component {
    state = {
        // Storages: [
        //     { icon: "/assets/icons/uploadmodal/paperclip.svg", title: "My Device" },
        //     { icon: "/assets/icons/uploadmodal/link.svg", title: "Link (URL)" },
        //     { icon: "/assets/icons/uploadmodal/googledrive.svg", title: "Google Drive" },
        //     { icon: "/assets/icons/uploadmodal/onedrive.svg", title: "One Drive" },
        //     { icon: "/assets/icons/uploadmodal/dropbox.svg", title: "DropBox" },
        // ],

        options: [

        ]
    }
    submitImport = () => {

        let tempId = nanoid()
        let file = this.props.importInfo?.file

        if (file) {
            this.setState({ isLoadingPost: true })

            let body = { ...this.props.importInfo }
            if (!body['**files']) {
                body['**files'] = {}
            }
            body['**files']['file'] = file
            body.schema = this.props.page?.extra?.import?.schema
            // body.populate = this.props.page?.populate
            body.importAPIName = this.props.page?.importAPIName
            body.type = 'record'
            delete body.file
            // console.log('bodeeeeeeeeeeeeyyyyyyyyyyy', body);
            // return
            HttpServices.request('submitImport', body, ((fetchResult, fetchError) => {

                this.setState({ isLoadingPost: false,uploaded:false },()=>{

                    this.props.hideModal()
                })

            }))


        }

    }

    handleInputChange(files) {
        let tempId = nanoid()
        // let paths = this.props.paths
        let uploadList = this.state.uploadingList ?? []
        uploadList = [files]
        this.setState({ uploadList, tempId });
        // console.log(uploadList)
        // console.log(this.props.applet)


        // console.log(files)
        files.forEach(file => {
            // HttpServices.addUploadQueque(file, { folder: this.props.applet?._id, type: 'upload', drive: '123', applet: this.props.applet }, tempId, (fetchResult, fetchError) => {
            //     this.props.changeStage("second")
            // })
            this.analyseExcel(file, () => {

                this.props.changeImportInfo('file', file, () => {
                    this.setState({ file },()=>{
                        setTimeout(() => {
                            this.setState({uploaded:true})
                        }, 2000);
                    })
                    // this.props.changeStage("mapData")
                })

            })

        });
    }


    render() {
        // let options = this.state.options
        // const dropzoneRef = React.createRef();
        // onClick={() => this.props.changeStage("second")}
        // console.log("this.props.queque?.uploads")

        let currentUpload = []
        if (this.state.tempId && this.props.queque?.uploads) {
            currentUpload = this.props.queque?.uploads.filter(file => file.tempId == this.state.tempId)
        }

        // let temp = [{ file: { name: 'test file' }, precentage: 50 }]

        return (

            <div className="w-100 h-100 br-10 p-2 flexcc flex-column" style={{ backgroundColor: "white", }} >
                {!this.state.file && (
                    <CustomDropZone className="w-100 h-100" disabled={false} information={{ accept: '.csv, application/vnd.ms-excel, text/csv' }} onDrop={(e) => this.handleInputChange(e, false)}>
                        <div className="h-100 w-100 flexcc flex-column p-5" style={{ border: "1px dashed rgb(186 186 186)", borderRadius:'10px' }}>
                            {/* <div className="p-5"> */}
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style={{width:'80px', height:'80px'}}>
                                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75" />
                            </svg>

                            {/* <img width={80} src="/assets/icons/applets/database/import-purple-big.svg" /> */}
                            <p className="pt-2">{translate('Browse files to upload')}</p>
                            <p className="font-size-14">{translate('or drag a file in here')}.</p>
                            <p className="font-size-12 mt-1" style={{ color: "#777" }}>{translate('Valid formats are csv, xls')}.</p>
                            {/* </div> */}
                        </div>
                    </CustomDropZone>
                )}


                {this.state.file && (
                    <div className="px-4 flexcc flex-column h-100">
                        {!this.state.uploaded ? (

                        <div className="px-3 w-100 mb-3">
                            <p className="text-semibold">{translate("در حال بارگذاری ...")}</p>
                        </div>
                        ):(
                        <div className="px-3 w-100 mb-3">
                            <p className="text-semibold">{translate("آماده بارگذاری")}</p>
                        </div>

                        )}
                        <div className="shadow-2 br-8 w-100 py-2">
                            {this.props.queque?.uploads?.map((item, index) => {

                                {/* {temp?.map((item, index) => { */ }
                                return (
                                    <div>
                                        <div className="uploaded-files-list p-3 scroll-no-scrollbar" style={{ display: "flex", flexDirection: "column", overflowY: "scroll" }}>
                                            <div>
                                                <span className="choosed-file">
                                                    <div className="flexcb w-100">
                                                        <div className="pb-2 font-size-14"> {item?.file?.name}</div>
                                                        <div className="value">
                                                            <div style={{ color: "black", fontSize: "11px" }}>
                                                                <span >{item.precentage ? item.precentage.toFixed(0) : 0}%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className=' flexc br-10' style={{ background: 'rgba(239, 239, 239,0.5)', height: '10px' }}>
                                                        <div className=" br-10" style={{ background: 'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))', width: item.precentage + '%', height: '10px' }}>
                                                        </div>
                                                    </div>
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                )}
                {this.state.uploaded &&(

                    <LoaderButton
                    onClick={this.submitImport}
                    isLoading={this.state.isLoadingPost}
                    text={translate("Import")}
                    type={"Oval"}
                    className="mt-3"
                    buttonStyle={{ outline: 'none', backgroundImage: 'linear-gradient(to right bottom,#ee5050,#dd2020)', cursor: 'pointer', padding: '10px 50px', borderRadius: 40, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                    width={40}
                    height={40}
                    color={'#677dc4'}
                    />
                    )}

            </div>



        );

    }




    analyseExcel = (file, cb) => {

        console.log("analyseExcel")
        console.log(file)

        if (file) {
            console.log(file)
            const reader = new FileReader();
            reader.onload = async (e) => {
                // console.log(e)
                const bstr = e.target.result

                // let result = excelToJson({
                //     sourceFile: fileee//fs.readFileSync(fileee)
                // });
                // console.log(result)
                // alert(text)

                const wb = read(bstr, { type: "binary" });
                // const wb = read(file);
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                let headersNames = this.get_header_row(ws)
                let fields = {}

                let headers = []

                if (Array.isArray(headersNames)) {
                    headersNames.forEach((header, index) => {
                        headers.push({ title: header, value: index })



                        this.props.headers.forEach(element => {

                            // if(header == 'Row ID'){

                            //     console.log(element)
                            //     console.log(header)


                            // }

                            if (element.key.toLowerCase() == header.trim().toLowerCase() || element.information.label.trim().toLowerCase() == header.trim().toLowerCase()) {
                                fields[element.key] = index
                            }
                        })

                    })
                }

                // console.log(fields)

                this.props.changeImportInfo('rawHeaders', headers, () => {
                    this.props.changeImportInfo('fields', fields, () => {

                        cb()
                    })

                })


                // const result = utils.sheet_to_json(ws, { header: headers, defval: '', blankrows: true, skipHeader: false });
                // console.log(result)
                // console.log(headers)
                // this.insertJsonToTable(result)


            };
            reader.readAsBinaryString(file)



            // let wb = XLSX.read(file)
            // const wb = XLSX.read(file);
            // console.log(wb)
            // const wsname = wb.SheetNames[0];
            // console.log(wsname)
            // const ws = wb.Sheets[wsname];
            // console.log(ws)
            // const result = XLSX.utils.sheet_to_json(ws, {header:["code","name","family"]});
            // console.log(result)

        }

    }



    get_header_row(sheet) {
        var headers = [];
        var range = utils.decode_range(sheet['!ref']);
        var C, R = range.s.r; /* start in the first row */
        /* walk every column in the range */
        for (C = range.s.c; C <= range.e.c; ++C) {
            var cell = sheet[utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */

            var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
            if (cell && cell.t) hdr = utils.format_cell(cell);

            headers.push(hdr);
        }
        return headers;
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, queque: state.queque })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportModalFirst);